module.exports = __webpack_public_path__ + "img/image3.e335e019.png";